package com.wintermar.inspection.core.ui.widget.table_container

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun HeaderTableContainer(
    items: List<String>,
    widthItems: List<Float> = emptyList(),
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Row(
        modifier = Modifier
            .padding(horizontal = dimension.spacing.space4)
            .fillMaxWidth()
            .background(
                color = color.surface.neutral.subtlest.default,
                shape = RoundedCornerShape(
                    topStart = dimension.radius.md,
                    topEnd = dimension.radius.md
                )
            )
            .border(
                width = 1.dp,
                color = color.border.subtle,
                shape = RoundedCornerShape(
                    topStart = dimension.radius.md,
                    topEnd = dimension.radius.md
                )
            )
            .padding(dimension.spacing.space4),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space1
        )
    ) {
        items.forEachIndexed { index, label ->
            TextBodySmall(
                text = label,
                bold = true,
                modifier = Modifier.weight(widthItems.getOrElse(index) { 1f })
            )
        }
    }
}
